/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- COMMENTING : GET CODE : STYLES --------------- ++++++++++ */
export default theme => ({
  commentingcodepage: {
    '& .cardwrapper': {
      background: '#FFF',
      width: '100%',
      height: '100%',
      minHeight: pxToEm(600),
      padding: pxToEm(40),
      '& .copysnippetfield, & .inlinemessage': {
        marginBottom: pxToEm(40)
      },
      '& .loaderwrapper': {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }
  }
});
